<div class="centered content-grid">
  <div class="white-background content">
    <h1>4😵4</h1>
    <h2>{{"notFound.headline" | transloco}}</h2>
    <p>{{"notFound.text" | transloco}}</p>
    <app-primary-button [label]="'notFound.btHome'" (onClick)="navigateToDashboard()"></app-primary-button>
  </div>
</div>
